import { render, staticRenderFns } from "./emailRegistration.vue?vue&type=template&id=23df79e2&scoped=true&"
import script from "./emailRegistration.vue?vue&type=script&lang=js&"
export * from "./emailRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df79e2",
  null
  
)

export default component.exports